/**
 * created by li si yi
 * 媒体列表
 */
import React, {Component} from 'react';
import {Icon, Input, Tree, DatePicker, Select, message} from 'antd'
import SwitchBounced from "../../components/switchBounced/SwitchBounced"
import '../EditorPublishInformation.css'
import Concurrently from "../concurrently/Concurrently";
import BaseComponent from "../../../../base/BaseComponent";
import folder from "./folder.png"

export default class MediaList extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            properties: true,
            mediaList: [],
            mediaListInfo: [],
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const {mediaListInfo} = this.state;
        return (
            <>
                {
                    mediaListInfo && mediaListInfo.map((item, index) => {
                        return (
                            <div style={{margin: '0 10px 10px 0', width: '100%', display: 'flex'}} key={item.key}>
                                <img style={{width: 22, height: 22, marginRight: 10}}
                                     src={item.mediaLogo ? item.mediaLogo : ''}/>
                                <span title={item.mediaName ? item.mediaName : ''} style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                }}>{item.mediaName ? item.mediaName : ''}</span>
                            </div>
                        )
                    })
                }
            </>
        )
    }

    setData = (mediaList) => {
        this.setState({
            mediaList
        }, () => {
            this.getMediaList(this.state.mediaList);
        })
    };

    // 根据id查询媒体
    getMediaList = (ids) => {
        let params = {
            ids: ids
        };
        this.request({
            url: '/cm-sites-pms/media/getMediaGroupByIds',
            body: params,
            callBack: (res) => {
                if (res && res.length) {
                    let mediaListInfo = [];
                    res.map(item => {
                        item.mediaList && item.mediaList.map(Item => {
                            mediaListInfo.push({
                                mediaName: Item.name ? Item.name : '',
                                mediaLogo: Item.mediaLogo ? Item.mediaLogo : item.logoUrl ? item.logoUrl : '',
                                key: Item.id ? Item.id : ''
                            })
                        })
                    });
                    this.setState({mediaListInfo})
                }
            }
        })
    };
}